import angular from "angular";
import template from "./admin-settings-policies-scheduling.html";
import AdminSettingsPoliciesSchedulingController from "./admin-settings-policies-scheduling.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.settings.policies.scheduling", {
    url: "/scheduling",
    controller: AdminSettingsPoliciesSchedulingController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.owner,
        USER_ROLES.administrator,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.settings.policies.scheduling", [])
  .config(config)
  .controller(
    "AdminSettingsPoliciesSchedulingController",
    AdminSettingsPoliciesSchedulingController,
  );
